import React, { useEffect, useState } from 'react';
import { Section } from '../components/layout';
import { useTranslation } from 'react-i18next';
import { useStateContext } from '../context/ContextProvider';
import { useDispatch, useSelector } from 'react-redux';
import { getAllServices } from '../redux/actions/services';
import { Loader, ServiceCard } from '../components/utils';
import { Link} from "react-router-dom";
import { IoArrowBackOutline } from 'react-icons/io5';
import Button from './layout/Button';
function Services() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading, Allservices, pagination } = useSelector((state) => state.Services);

  // إضافة state لإدارة الصفحة الحالية وعدد العناصر في الصفحة
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6); // يمكنك تغيير القيمة الافتراضية هنا

  useEffect(() => {
    // استدعاء getAllServices مع page و limit الحاليين
    dispatch(getAllServices(page, limit));
  }, [page, limit, dispatch]);

  // دالة للانتقال إلى الصفحة التالية
  {/*const handleNextPage = () => {
    if (page < pagination.totalPages) {
      setPage(page + 1);
    }
  };

  // دالة للانتقال إلى الصفحة السابقة
  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
*/}
  return (
    <div>
      {isLoading ? (
      <Loader />
      ) : (
        <Section>
          <div className="flex-col">
            <div className="flex mb-5 max-w-[40rem] flex-col">
              <h2 className="h2 text-color-1 dark:text-tcolor-1 mb-4 md:mb-8">
                {t("The practices")}
              </h2>
              <h2 className="h3 text-tcolor-4 dark:text-tcolor-1 mb-4 md:mb-8">
                {t("we cover to meet your needs")}
              </h2>
            </div>

            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-4 sm:grid-cols-1">
              {Allservices?.map((service, index) => (
                <ServiceCard key={index} service={service} />
              ))}
            </div>
            <div className=" w-full flex items-end justify-end"> <Link to={"/AllServiceses"}    onClick={() => {
          
          window.scrollTo(0, 0); 
      
        }}> <Button text={t('More')} Transform={true}  nonBackground={true} Bstyle={"mt-10"}  textColor={"text-color-1"} icon={<IoArrowBackOutline />}/></Link> </div>
         
          
          </div>
        </Section>
      )}
    </div>
  );
}

export default Services;